import React from 'react';
import './styles/style.css';

const SecondaryButton = ({
  icon,
  text,
  onClick,
  disabled = false,
  type = 'button',
  size = 'M',
  className = '',
  ...props
}) => {
  const sizeClass = size === 'S' ? 'secondaryButton--sm' : size === 'L' ? 'secondaryButton--lg' : '';

  return (
    <button
      type={type}
      className={`secondaryButton ${sizeClass} ${disabled ? 'disabled' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && (
        <span translate="no" className="secondaryButton-icon material-symbols-sharp">
          {icon}
        </span>
      )}
      <span className="secondaryButton-text">{text}</span>
    </button>
  );
};

export default SecondaryButton;